import { TFunction } from 'react-i18next'
import * as yup from 'yup'
import { isValidAmount, isValidAmountWithMax } from 'pages/Rewards/utils'

const getWalletSchema = (t: TFunction<'translation', undefined>) =>
  yup.object<Record<string, yup.AnySchema>>({
    value: yup.string().required(t('rewards.withdraw.walletRequired')),
    name: yup.string().required(t('rewards.withdraw.walletRequired')),
  })

export const getDepositValidationSchema = (
  t: TFunction<'translation', undefined>,
  maxAmount: number
) =>
  yup.object().shape({
    currency: yup.string().required(t('rewards.withdraw.currencyRequired')),
    allocateFrom: getWalletSchema(t).nullable().required(t('rewards.deposit.allocateFromRequired')),
    amount: yup
      .string()
      .required(t('rewards.deposit.amountRequired'))
      .test('is-valid-amount', t('rewards.deposit.amountInvalid'), isValidAmount)
      .test('max-amount', t('rewards.deposit.amountExceedsMax'), value =>
        isValidAmountWithMax(value, maxAmount)
      ),
    termsAccepted: yup
      .boolean()
      .oneOf([true], t('rewards.deposit.termsAcceptedRequired'))
      .required(t('rewards.deposit.termsAcceptedRequired')),
  })

export const getWithdrawValidationSchema = (
  t: TFunction<'translation', undefined>,
  maxAmount: number
) =>
  yup.object().shape({
    currency: yup.string().required(t('rewards.withdraw.currencyRequired')),
    withdrawToWallet: getWalletSchema(t).nullable().required(t('rewards.withdraw.walletRequired')),
    amount: yup
      .string()
      .required(t('rewards.withdraw.amountRequired'))
      .test('is-valid-amount', t('rewards.withdraw.amountInvalid'), isValidAmount)
      .test('max-amount', t('rewards.withdraw.amountExceedsMax'), value =>
        isValidAmountWithMax(value, maxAmount)
      ),
  })
